export const PREDICT_KEY = 'PREDICT';
export const REQUIRED_KEY = 0;
